<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="tooltip-box">
    <slot />
    <div
      class="tooltip"
    >
      <span class="text" v-html="text"></span>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.tooltip-box {
  position: relative;
  display: inline-block;
}

.tooltip-box:hover .tooltip {
  opacity: 1;
  display: initial;
}

.tooltip {
  min-width: 230px;
  background: $white;
  border: 1px solid $dark-gray;
  border-radius: 5px;

  padding: 10px;
  bottom: 30px;
  margin-left: -140px;

  opacity: 0;
  transition: opacity 1s;

  display: none;
  position: absolute;
  z-index: 10;
}

.text {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  text-transform: none;
  color: $gray;
}

.text::after {
  content: " ";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 6px;
  border-style: solid;
  border-color: $dark-gray transparent transparent transparent;
}
</style>
